import {DotIcon} from '@primer/octicons-react'

import {RebaseState} from '../../../../hooks/mutations/use-stack-rebase-mutation'

export function SkippedIcon({state}: {state?: RebaseState}) {
  if (state !== RebaseState.Skipped) return null

  return <DotIcon className="color-fg-muted" />
}
